import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LuLandingPageSectionTypeAppResource from './LuLandingPageSectionTypeAppResource';
import LuWorkspaceMembershipTypeAppResource from './LuWorkspaceMembershipTypeAppResource';
import MLSAppResource from './MLSAppResource';
import PlaybookAppResource from './PlaybookAppResource';

class LandingPageBuySectionAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-buy-section';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/buys/sections';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'landingPageSectionTypeId',
      'mlsPublicAccess',
      'hasTour',
      'hasOffer',
      'hasFinance',
      'hasTrade',
      'location',
      'projectMembershipTypeUuid',
      'homePurchasePlaybookUuid',
      'mlsUuid',
      'landingPage',
      'type',
      'projectMemberType',
      'playbook',
      'mls',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage:             LandingPageAppResource,
      type:             LuLandingPageSectionTypeAppResource,
      projectMemberType:             LuWorkspaceMembershipTypeAppResource,
      playbook:             PlaybookAppResource,
      mls:             MLSAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
      type: 'landing_page_section_type_id',
      projectMemberType: 'project_membership_type_uuid',
      playbook: 'home_purchase_playbook_uuid',
      mls: 'mls_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    let rules = {
      landingPageUuid: {
        type: 'string',
      },
      landingPageSectionTypeId: {
        type: 'integer',
        presence:                 true,
      },
      mlsPublicAccess: {
        type: 'boolean',
      },
      hasTour: {
        type: 'boolean',
      },
      hasOffer: {
        type: 'boolean',
      },
      hasFinance: {
        type: 'boolean',
      },
      hasTrade: {
        type: 'boolean',
      },
      projectMembershipTypeUuid: {
        type: 'string',
        presence:                 true,
      },
      homePurchasePlaybookUuid: {
        type: 'string',
      },
      mlsUuid: {
        type: 'string',
      },
      location: {
        type: 'object',
      },
    };

    if (this.mlsPublicAccess) {
      rules.mlsUuid.presence = {message: "^Please select a Mls."};
    }

    return rules;
  }
}

export default LandingPageBuySectionAppResource;
